import ImageFormatter from "@/ui/image-formatter/image-formatter";
import React from "react";
import {SearchResult} from './SearchBox'
import Box from "@mui/material/Box";
import {Theme} from "@mui/material/styles";


const ResultBox = ({
                       name,
                       slug,
                       image,
                       description,
                       categoryType,
                       categorySlug,
                   }: SearchResult) => {

    return (<Box key={slug} sx={(theme: Theme) => ({
            p: 2,
            borderBottom: `1.5px solid ${theme.palette.grey[400]}`,
            transition: 'background-color 0.3s ease, color 0.3s ease',
            '&:hover  ': {
                color: theme.palette.primary.main,
                backgroundColor: '#c8cfd4',
            }
        })}>
            <a href={`/${categoryType}/${categorySlug}/${slug}`} className="text-sm text-gray-600">
                <div className="flex gap-4">
                    <ImageFormatter alt={name}
                                    isBackground
                                    src={image}
                                    height='70px'
                                    width='120px'
                    />
                    <div>
                        <p className="uppercase text-[10px]">{categoryType}</p>
                        <p className="font-semibold">{name}</p>
                        <p className="text-[12px]">{description}</p>
                        {/*<p className="text-[10px]">{categorySlug}-{slug}</p>*/}
                    </div>
                </div>
            </a>
        </Box>
    )
}

export default ResultBox
